import React from 'react';
import ContainerBase from '@material-ui/core/Container';

const Container = (props) => <ContainerBase {...props} />;

export default Container;
